import PageHeader from "../../components/common/PageHeader";


const DefaultContent: React.FC = () => {
  return (
    <>
      <PageHeader title="Welcome to WesternAva" />
      <div>
        <div className="mb-4">
          Western Ava represents our bespoke solution, architected on AWS, to revolutionize our approach to data management and tool integration.
          This platform is engineered to enhance our operational efficiency and intelligence by harnessing the power of data-driven decision-making.
          It's not just a platform; it's our step towards smarter workflows and insightful analytics.
        </div>
        <div>
          <h4>Notification Framework:</h4>
          <p>
            At the heart of this platform lies a robust framework for dispatching notifications and alerts, drawing on data from our core systems, such as IMOS and SEDNA.
            This is pivotal for maintaining operational fluency, as it ensures users are prompted to complete essential tasks and address system anomalies promptly.
            By delivering real-time alerts, this framework acts as a safeguard against oversight and facilitates swift corrective measures, ensuring a seamless operational cadence.
          </p>
        </div>
        <div>
          <h4>Algorithmic Trading Framework:</h4>
          <p>
            A dedicated framework for algorithmic trading signals is a significant asset for the FFA-Desk.
            It equips our trading teams with sophisticated analytical tools that harness advanced algorithms, enabling them to decipher market trends and execute trades with precision.
            This capability is not just a technological advancement; it's a strategic enabler that underpins informed decision-making and can significantly enhance our competitive edge in the marketplace.
          </p>
        </div>
        <div>
          <h4>Data Integration Framework:</h4>
          <p>
            Integrating various data sources via IMOS Webhooks represents a leap forward in data utilization.
            By aggregating external data streams—ranging from weather conditions to Rightship evaluations and voyage completion forms. This framework ensures a rich tapestry of information is at our fingertips.
            This integrative approach is instrumental in painting a comprehensive picture of operational contexts, allowing for more nuanced and informed decisions that can positively impact voyage outcomes and efficiency.
          </p>
        </div>
      </div>
    </>
  );
};

export default DefaultContent;